import { CardAdapter, walletError } from '../types'

let formCounter = 0

/** PayU Secure Form - pola karty żyją w iframe'ach operatora, do nas wraca tylko token. */
export const payuCardAdapter: CardAdapter = {
  create(cardForm, { lang = 'pl', placeholders, onReady } = {}) {
    const PayU = window.PayU
    if (typeof PayU !== 'function') throw walletError('card_sdk_not_loaded')

    const payu = PayU(cardForm.posId, { dev: !!cardForm.sandbox })
    const forms = payu.secureForms()
    const card = forms.add('card', {
      lang,
      placeholder: {
        number: placeholders?.number || '',
        date: placeholders?.date || '',
        cvv: placeholders?.cvv || ''
      }
    })

    const fallbackId = `payu-card-form-${++formCounter}`

    return {
      mount(element) {
        // Secure Form przyjmuje WYŁĄCZNIE selektor CSS jako string - podanie węzła DOM
        // kończy się błędem `element.selector.not.string`
        if (!element.id) element.id = fallbackId
        card.render(`#${element.id}`)
        onReady?.(true)
      },

      async tokenize(kind) {
        const tokenType = cardForm.tokenTypes?.[kind] || cardForm.tokenTypes?.single
        if (!tokenType) throw walletError('card_token_type_missing')

        const result = await payu.tokenize(tokenType)
        if (result?.status !== 'SUCCESS' || !result?.body?.token) {
          // komunikat operatora jest po polsku i nadaje się do pokazania wprost
          throw walletError('card_tokenize_failed', result?.error?.messages?.[0]?.message)
        }
        return result.body.token as string
      },

      destroy() {
        try {
          card.remove?.()
        } catch (_) {
          // starsze wersje SDK nie mają remove()
        }
      }
    }
  }
}
